import { merge } from 'lodash'
import Block from './block'

class ImageMapBlock extends Block {

  constructor(block) {
    super(block)
    this.type = 'image_map'
    this.alias = `圖片地圖 - ${this.uid}`
    this.mobile = {
      image: {
        url: '',
        size: 0,
        width: 0,
        height: 0,
        title: ''
      },
      areas: [],
      linkables: []
    }
    this.desktop = {
      image: {
        url: '',
        size: 0,
        width: 0,
        height: 0,
        title: ''
      },
      areas: [],
      linkables: []
    }

    if (block) {
      merge(this, block)
    }
  }

}

export default ImageMapBlock



// WEBPACK FOOTER //
// ./src/models/blocks/image_map.js